import type {
    NavigationGuardReturn,
    RouteLocationAsRelativeGeneric,
    RouteLocationNormalized,
} from 'vue-router';
import {useSpaceSelectionStore} from '../../stores/booking/spaceSelectionStore';
import {useUserStore} from '../../stores/userStore';
import {useFeatureFlagStore} from '../../stores/featureFlagStore';

export async function beforeEnterBooking(
    to: RouteLocationNormalized
): Promise<NavigationGuardReturn> {
    if (to.name === 'BookingMap') {
        return;
    }
    const {selectedRoomId} = useSpaceSelectionStore();
    if (selectedRoomId) {
        return getBookingMapTargetRoute(selectedRoomId, to);
    }
    const {user} = useUserStore();
    if (user?.primaryRoom?.id) {
        return getBookingMapTargetRoute(user.primaryRoom.id, to);
    }
}

export async function beforeEnterDetailPage(
    to: RouteLocationNormalized
): Promise<NavigationGuardReturn> {
    const featureAllowed = await useFeatureFlagStore().bookingDetailPage.isReady();

    if (!featureAllowed) {
        return {name: 'Home'};
    }

    if (to.name === 'BookingResourceDetails') {
        return;
    }
}

function getBookingMapTargetRoute(
    roomId: string,
    to: RouteLocationNormalized
): RouteLocationAsRelativeGeneric | undefined {
    if (to.name === 'BookingMap' && to.params.roomId === roomId) {
        return;
    }
    return {
        name: 'BookingMap',
        params: {roomId: roomId},
        query: to.query,
    };
}
